import type { Settings } from 'src/types/settings';

import { createContext } from 'react';

export const defaultSettings: Settings = {
  colorPreset: 'indigo',
  contrast: 'normal',
  direction: 'ltr',
  layout: 'vertical',
  navColor: 'evident',
  paletteMode: 'light',
  responsiveFontSizes: true,
  stretch: false,
};

export interface State extends Settings {
  openDrawer: boolean;
  isInitialized: boolean;
  sidebarCollapsed: boolean;
}

export const initialState: State = {
  ...defaultSettings,
  isInitialized: false,
  openDrawer: false,
  sidebarCollapsed: false,
};

export interface SettingsContextType extends State {
  handleDrawerClose: () => void;
  handleDrawerOpen: () => void;
  handleReset: () => void;
  handleUpdate: (settings: Settings) => void;
  handleSidebarCollapse: () => void;
  isCustom: boolean;
}

export const SettingsContext = createContext<SettingsContextType>({
  ...initialState,
  handleDrawerClose: () => {
    // Add your implementation here
  },
  handleDrawerOpen: () => {
    // Add your implementation here
  },
  handleReset: () => {
    // Add your implementation here
  },
  handleUpdate: () => {
    // Add your implementation here
  },
  handleSidebarCollapse: () => {
    // Add your implementation here
  },
  isCustom: false,
});
